import React from 'react';
import { SupportedLanguage } from '@/config/site.config';

interface FlagIconProps {
  language: SupportedLanguage;
  className?: string;
}

const FlagIcon: React.FC<FlagIconProps> = ({ language, className = "w-5 h-4" }) => {
  const flags: Record<SupportedLanguage, React.ReactNode> = {
    en: (
      <svg viewBox="0 0 640 480" className={className}>
        <path fill="#012169" d="M0 0h640v480H0z"/>
        <path fill="#FFF" d="m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0h75z"/>
        <path fill="#C8102E" d="m424 281 216 159v40L369 281h55zm-184 20 6 35L54 480H0l240-179zM640 0v3L391 191l2-44L590 0h50zM0 0l239 176h-60L0 42V0z"/>
        <path fill="#FFF" d="M241 0v480h160V0H241zM0 160v160h640V160H0z"/>
        <path fill="#C8102E" d="M0 193v96h640v-96H0zM273 0v480h96V0h-96z"/>
      </svg>
    ),
    ua: (
      <svg viewBox="0 0 640 480" className={className}>
        <g fillRule="evenodd" strokeWidth="1pt">
          <path fill="#0057b8" d="M0 0h640v240H0z"/>
          <path fill="#ffd700" d="M0 240h640v240H0z"/>
        </g>
      </svg>
    ),
    ru: (
      <svg viewBox="0 0 640 480" className={className}>
        <g fillRule="evenodd" strokeWidth="1pt">
          <path fill="#fff" d="M0 0h640v160H0z"/>
          <path fill="#0039a6" d="M0 160h640v160H0z"/>
          <path fill="#d52b1e" d="M0 320h640v160H0z"/>
        </g>
      </svg>
    ),
    es: (
      <svg viewBox="0 0 640 480" className={className}>
        <path fill="#c60b1e" d="M0 0h640v480H0z"/>
        <path fill="#ffc400" d="M0 120h640v240H0z"/>
      </svg>
    ),
    pt: (
      <svg viewBox="0 0 640 480" className={className}>
        <path fill="#006600" d="M0 0h240v480H0z"/>
        <path fill="#ffcc00" d="M240 0h400v480H240z"/>
        <circle cx="240" cy="240" r="80" fill="#cc0000"/>
        <circle cx="240" cy="240" r="60" fill="#fff"/>
        <path fill="#3399ff" d="M200 200h80v80h-80z"/>
      </svg>
    ),
    fr: (
      <svg viewBox="0 0 640 480" className={className}>
        <g fillRule="evenodd" strokeWidth="1pt">
          <path fill="#002654" d="M0 0h213.3v480H0z"/>
          <path fill="#fff" d="M213.3 0h213.4v480H213.3z"/>
          <path fill="#ce1126" d="M426.7 0H640v480H426.7z"/>
        </g>
      </svg>
    ),
    de: (
      <svg viewBox="0 0 640 480" className={className}>
        <path fill="#000" d="M0 0h640v160H0z"/>
        <path fill="#D00" d="M0 160h640v160H0z"/>
        <path fill="#FFCE00" d="M0 320h640v160H0z"/>
      </svg>
    ),
  };

  return <span className="inline-flex items-center shrink-0">{flags[language]}</span>;
};

export default FlagIcon;
